import $ from 'jquery'
import c3 from 'c3'

function generateLineChart(bindTo, columns, x_columns, width= 890) {
    c3.generate({
        bindto: bindTo,
        data: {
            columns: columns,
            labels: true,
            type: 'area-spline',
            colors: { data1: '#5ab9d9' },
        },
        axis: {
            x: {
                height: 50,
                tick: { format: function (x) { return x_columns[x]; }, fit: false }
            },
            y: { tick: { values: [1, 2, 3, 4, 5] }, min: 1, max: 5 }
        },
        legend: { show: false },
        padding: { bottom: 0, top: 0, left: 30, right: 20 },
        size: { width: width }
    });
}

function generateNoLabelLineChart(bindTo, columns, formatSortDataColumn, rightPadding = 20, witdhResize = 890) {
    if (Array.isArray(columns) && (columns.length > 1 && columns.find(column => column[0] === 'score').slice(1).every(score => score === 1))) {
        $(`${bindTo}`).css({
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '5px'
        }).html(`<div class="container rounded-xl py-1 px-3 border-2 h-24 w-3/4" style="background-color: rgb(251 252 253);">
                    <p style="font-size: 14px; color: #666">
                        Source not connected, add source in 
                        <a href="/dashboard/backends?_account=${$('input[name="_account"]').val()}" target="_blank">connections tab</a>
                    </p>
                </div>`);
    } else {
        columns = columns.map(column => column.map(item => item === 1 ? null : item));
        c3.generate({
            bindto: bindTo,
            data: {
                columns: columns,
                labels: false,
                type: 'spline',
                colors: { data1: '#5ab9d9' },
            },
            axis: {
                x: {
                    tick: { 
                        format: function (x) { return '' },
                        culling: { max: 4 }
                    }
                },
                y: { tick: { 
                    values: [1, 2, 3, 4, 5] },
                    min: 2,
                    max: 5
                }
            },
            legend: { show: false },
            padding: { bottom: 0, top: 0, left: 40, right: rightPadding },
            size: { width: 890 },
            tooltip: {
                contents: function (d, defaultTitleFormat, defaultValueFormat, color) {
                    var $$ = this, config = $$.config,
                        titleFormat = config.tooltip_format_title || defaultTitleFormat,
                        nameFormat = config.tooltip_format_name || function (name) { return name; },
                        valueFormat = config.tooltip_format_value || defaultValueFormat,
                        text, i, title, value, name, bgcolor;
                
                    for (i = 0; i < d.length; i++) {
                        if (!(d[i] && (d[i].value || d[i].value === 0))) { continue; }
                        if (!text) {
                        title = titleFormat ? formatSortDataColumn[d[i].x] : d[i].x;
                        text = "<table class='" + $$.CLASS.tooltip + "'>";
                        text += "<tr><th>" + title + "</th>";
                        }
                        name = nameFormat(d[i].name);
                        value = valueFormat(d[i].value, d[i].ratio, d[i].id, d[i].index);
                        bgcolor = $$.levelColor ? $$.levelColor(d[i].value) : color(d[i].id);
                        text += "<tr class='" + $$.CLASS.tooltipName + "-" + d[i].id + "'>";
                        text += "<td class='name'><span style='background-color:" + bgcolor + "'></span>" + name + "</td>";
                        text += "<td class='value'>" + value + "</td>";
                        text += "</tr>";
                    };
                    return text + "</table>";
                }
            }
        }).resize({width: witdhResize});
    }
}

function generateLegend(legendSelector, chart1, chart2, labels) {
    let legendContainer = d3.select(legendSelector).select('.legend');
    const isMobile = window.innerWidth < 640;
    if (legendContainer.empty()) {
        legendContainer = d3.select(legendSelector).insert('div', '.chart').attr('class', 'legend');
        if (isMobile) {
            labels = labels.map(label => label.slice(0, 1));
        }
        legendContainer.selectAll('span')
            .data(labels)
            .enter().append('span')
            .append('span')
            .attr('data-id', function(id) { return id; })
            .each(function(id) {
                d3.select(this).style('background-color', chart1.color(id));
                d3.select(this).node().parentNode.insertBefore(
                    document.createTextNode("" + id),
                    d3.select(this).node().nextSibling
                );
            });
    }
    legendContainer.selectAll('span')
        .on('mouseover', function(id) {
            chart1.focus(id);
            chart2.focus(id);
        })
        .on('mouseout', function(id) {
            chart1.revert();
            chart2.revert();
        })
        .on('click', function(id) {
            chart1.toggle(id);
            chart2.toggle(id);
        });
    return legendContainer;
}

function generateStackBarReviewChart(bindTo, columns, formatSortDataColumn, sortDataColumn, sortDataType, ratio = 0.6, showLegend = true, width = 890) {
  return c3.generate({
		bindto: bindTo,
		data: {
			columns: columns,
			type: 'bar',
			groups: [['5 stars', '4 stars', '3 stars', '2 stars', '1 star']],
			order: function (a, b) { return a.id[0] - b.id[0] }
		},
		bar: {
			width: {
				ratio: ratio
			}
		},
		axis: {
			x: { type: 'category', categories: formatSortDataColumn, height: 50 },
			y: { lines: [{value:0}] }
		},
		padding: { bottom: 0, top: 0, left: 50, right: 20 },
		size: { width: width },
		color: { pattern: ['#009e3c', '#7cc522', '#f8f400', '#ee9b00', '#de0023'] },
		tooltip: {
			contents: function (d, defaultTitleFormat, defaultValueFormat, color) {
				var $$ = this, config = $$.config,
				titleFormat = config.tooltip_format_title || defaultTitleFormat,
				nameFormat = config.tooltip_format_name || function (name) { return name; },
				valueFormat = config.tooltip_format_value || defaultValueFormat,
				text, i, title, value, name, bgcolor;

				var totalReviews = d.reduce(function (sum, item) {
						return sum + item.value;
				}, 0);
		
				d.sort(function (a, b) {
						return nameFormat(b.name).localeCompare(nameFormat(a.name));
				});
		
				for (i = 0; i < d.length; i++) {
					if (!(d[i] && (d[i].value || d[i].value === 0))) { continue; }
					if (!text) {
						title = titleFormat ? sortDataColumn[d[i].x] : d[i].x;
						text = "<table class='" + $$.CLASS.tooltip + "'>";
						text += "<tr><th>" + sortDataType + ' - ' + title + "</th>";
						text += "<th style='text-align:right;'>" + totalReviews + "</th></tr>";
					}
					name = nameFormat(d[i].name);
					value = valueFormat(d[i].value, d[i].ratio, d[i].id, d[i].index);
					bgcolor = $$.levelColor ? $$.levelColor(d[i].value) : color(d[i].id);
					text += "<tr class='" + $$.CLASS.tooltipName + "-" + d[i].id + "'>";
					text += "<td class='name'><span style='background-color:" + bgcolor + "'></span>" + name + "</td>";
					text += "<td class='value'>" + value + "</td>";
					text += "</tr>";
				}
				return text + "</table>";
			}
		},
		legend: {
			show: showLegend
		}
	});
}

function generateNoLabelStackBarReviewChart(bindTo, columns, sortDataColumn, formatSortDataColumn, sortDataType, witdhResize = 890) {
    if (columns.every(column => column.slice(1).every(value => value === 0))) {
        $(`${bindTo}`).css({
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '5px'
        }).html(`<div class="container rounded-xl py-1 px-3 border-2 h-24 w-3/4" style="background-color: rgb(251 252 253);">
                    <p style="font-size: 14px; color: #666">
                        Source not connected, add source in 
                        <a href="/dashboard/backends?_account=${$('input[name="_account"]').val()}" target="_blank">connections tab</a>
                    </p>
                </div>`);
    } else {
        c3.generate({
            bindto: bindTo,
            data: {
                columns: columns,
                type: 'bar',
                groups: [['5 stars', '4 stars', '3 stars', '2 stars', '1 star']],
                order: function (a, b) { return a.id[0] - b.id[0]; }
            },
            axis: {
                x: {
                    tick: { 
                        format: function (x) { return '' },
                        culling: { max: 4 }
                    }
                },
                y: { lines: [{value:0}] }
            },
            legend: { show: false },
            padding: { bottom: 0, top: 0, left: 40, right: 20 },
            size: { width: 890 },
            color: { pattern: ['#009e3c', '#7cc522', '#f8f400', '#ee9b00', '#de0023'] },
            tooltip: {
                contents: function (d, defaultTitleFormat, defaultValueFormat, color) {
                    var $$ = this, config = $$.config,
                        titleFormat = config.tooltip_format_title || defaultTitleFormat,
                        nameFormat = config.tooltip_format_name || function (name) { return name; },
                        valueFormat = config.tooltip_format_value || defaultValueFormat,
                        text, i, title, value, name, bgcolor;
                
                    var totalReviews = d.reduce(function (sum, item) { return sum + item.value; }, 0);
                
                    d.sort(function (a, b) { return nameFormat(b.name).localeCompare(nameFormat(a.name)); });
                
                    for (i = 0; i < d.length; i++) {
                        if (!(d[i] && (d[i].value || d[i].value === 0))) { continue; }
                        if (!text) {
                        title = titleFormat ? sortDataColumn[d[i].x] : d[i].x;
                        text = "<table class='" + $$.CLASS.tooltip + "'>";
                        text += "<tr><th>" + sortDataType + ' - ' + title + "</th>";
                        text += "<th style='text-align:right;'>" + totalReviews + "</th></tr>";
                        }
                        name = nameFormat(d[i].name);
                        value = valueFormat(d[i].value, d[i].ratio, d[i].id, d[i].index);
                        bgcolor = $$.levelColor ? $$.levelColor(d[i].value) : color(d[i].id);
                        text += "<tr class='" + $$.CLASS.tooltipName + "-" + d[i].id + "'>";
                        text += "<td class='name'><span style='background-color:" + bgcolor + "'></span>" + name + "</td>";
                        text += "<td class='value'>" + value + "</td>";
                        text += "</tr>";
                    }
                    return text + "</table>";
                }
            }
        }).resize({width: witdhResize});
    }
}

function generateStackBarSourceChart(bindTo, columns, customOrder, format_sort_data_column, sort_data_column, sort_data_type, ratio = 0.6, showLegend = true, width = 890) {
    return c3.generate({
        bindto: bindTo,
        data: {
            columns: columns,
            type: 'bar',
            groups: [
                ['Google', 'Tripadvisor', 'Viator', 'GetYourGuide', 'Expedia']
            ],
            order: function (a, b) {
                return customOrder.indexOf(b.id) - customOrder.indexOf(a.id);
            }
        },
        axis: {
            x: {
                type: 'category',
                categories: format_sort_data_column,
                height: 50,
            },
            y: {
                lines: [{value:0}]
            }
        },
        bar: {
			width: {
				ratio: ratio
			}
		},
        grid: {
            y: {
                lines: [{value:0}]
            }
        },
        padding: {
            bottom: 0,
            top: 0,
            left: 50, right: 20
        },
        size: {
            width: width
        },
        color: {
            pattern: ['#4285F4', '#34E0A1', '#004757', '#E76037', '#FDDB32']
        },
        tooltip: {
            contents: function (d, defaultTitleFormat, defaultValueFormat, color) {
                var $$ = this, config = $$.config,
                    titleFormat = config.tooltip_format_title || defaultTitleFormat,
                    nameFormat = config.tooltip_format_name || function (name) { return name; },
                    valueFormat = config.tooltip_format_value || defaultValueFormat,
                    text, i, title, value, name, bgcolor;
                
                var totalReviews = d.reduce(function (sum, item) {
                    return sum + item.value;
                }, 0);
            
                d.sort(function (a, b) {
                    return customOrder.indexOf(nameFormat(a.name)) - customOrder.indexOf(nameFormat(b.name));
                });
                
                for (i = 0; i < d.length; i++) {
                    if (!(d[i] && (d[i].value || d[i].value === 0))) { continue; }
                    if (!text) {
                    title = titleFormat ? sort_data_column[d[i].x] : d[i].x;
                    text = "<table class='" + $$.CLASS.tooltip + "'>";
                    text += "<tr><th>" + sort_data_type + ' - ' + title + "</th>";
                    text += "<th style='text-align:right;'>" + totalReviews + "</th></tr>";
                    }
                    name = nameFormat(d[i].name);
                    value = valueFormat(d[i].value, d[i].ratio, d[i].id, d[i].index);
                    bgcolor = $$.levelColor ? $$.levelColor(d[i].value) : color(d[i].id);
                    text += "<tr class='" + $$.CLASS.tooltipName + "-" + d[i].id + "'>";
                    text += "<td class='name'><span style='background-color:" + bgcolor + "'></span>" + name + "</td>";
                    text += "<td class='value'>" + value + "</td>";
                    text += "</tr>";
                }
                return text + "</table>";
            }
        },
        legend: { show: showLegend }
    });
}

function generateScoreArrays(data1, data2) {
    return [
        [['score', ...data1.map(subArray => subArray[0])]],
        [['score', ...data1.map(subArray => subArray[1])]],
        [['score', ...data1.map(subArray => subArray[2])]],
        [['score', ...data1.map(subArray => subArray[3])]],
        [['score', ...data2]],
    ];
}

function generateScatterChart(bindTo, columns, format_sort_data_column, witdhResize = 890) {
    let score_x = ['score_x', ...columns[0].slice(1).map((_, i) => i + 1)];
    columns[0] = columns[0].map(item => item === 1 ? null : item);
    columns.unshift(score_x);
    c3.generate({
        bindto: bindTo,
        data: {
            xs: { score: 'score_x'},
            columns: columns,
            labels: false,
            type: 'scatter',
            colors: { data1: '#5ab9d9' },
        },
        axis: {
            x: {
                tick: { 
                    format: function (x) { return format_sort_data_column[x]; },
                    culling: { max: 4 }
                }
            },
            y: {
                tick: { values: [1, 2, 3, 4, 5] },
                min: 1,
                max: 5
            }
        },
        legend: { show: false },
        padding: { bottom: 0, top: 0, left: 20, right: 20 },
        size: { width: 890 },
        point: {
            r: 4
        }
    }).resize({ width: witdhResize });
}

function generateDonutChartWithLegend(selector, data, patern, width = 200) {
    return c3.generate({
        bindto: selector,
        data: {
            columns: data,
            type : 'donut',
            labels: true
        },
        color: { pattern: patern },
        tooltip: {
            format: {
                value: function (value) {
                    return value;
                }
            }
        },
        legend: {
            show: false
        },
        onrendered: function () {
            d3.selectAll(`${selector} .c3-chart-arc text`).style('fill', 'black');
        }
    })
}

function createFakeBarChart(selector, data, colors) {
  const container = document.querySelector(selector);
  if (container) {
    const total = data.reduce((sum, item) => sum + item[1], 0);
    container.innerHTML = data.map((item, index) => {
      const percentage = (item[1] / total) * 100;
      const borderRadius = index === 0 ? '8px 0 0 8px' : (index === data.length - 1 ? '0 8px 8px 0' : '0');
      return `<div class="fake-bar" style="width: ${percentage}%; background-color: ${colors[index]}; height: 100%; border-radius: ${borderRadius};"></div>`;
    }).join('');
  }
}

window.display_chart = function() {
    let width_donus_chart = 200;
    let width_bar_chart = 250;
    
    var optionDonutChartReviewGoogle = $(".chart_data_google.hidden").data("chart");
    var optionDonutChartReviewTA = $(".chart_data_ta.hidden").data("chart");

    var rawBarDataGoogle = $(".bar-chart_data_google").data("chart");
    var sort_data_column_google;
    if (rawBarDataGoogle != null) {
        sort_data_column_google = rawBarDataGoogle.shift();
    }
    
    var rawBarDataTA = $(".bar-chart_data_ta").data("chart");
    var sort_data_column_ta;
    const patern = ['#009e3c', '#7cc522', '#f8f300', '#ee9b00', '#de0023']
    const dataDonutChartReviewGoogle = [
        ['5 stars', optionDonutChartReviewGoogle.star_ratings?.five_star || 0],
        ['4 stars', optionDonutChartReviewGoogle.star_ratings?.four_star || 0],
        ['3 stars', optionDonutChartReviewGoogle.star_ratings?.three_star || 0],
        ['2 stars', optionDonutChartReviewGoogle.star_ratings?.second_star || 0],
        ['1 star', optionDonutChartReviewGoogle.star_ratings?.one_star || 0]
    ]
    const dataDonutChartReviewTA = [
        ['5 stars', optionDonutChartReviewTA.star_ratings?.five_star || 0],
        ['4 stars', optionDonutChartReviewTA.star_ratings?.four_star || 0],
        ['3 stars', optionDonutChartReviewTA.star_ratings?.three_star || 0],
        ['2 stars', optionDonutChartReviewTA.star_ratings?.second_star || 0],
        ['1 star', optionDonutChartReviewTA.star_ratings?.one_star || 0]
    ]
    if (rawBarDataTA != null) {
        sort_data_column_ta = rawBarDataTA.shift();
    }
    if (optionDonutChartReviewGoogle != null) {
        var chartDonutGoogle = generateDonutChartWithLegend('#chart-donut-google', dataDonutChartReviewGoogle, patern);
        chartDonutGoogle.resize({ width: width_donus_chart, height: 250 });
    }
    if (optionDonutChartReviewTA != null) {
        var chartDonutTA = generateDonutChartWithLegend('#chart-donut-ta', dataDonutChartReviewTA, patern);
        chartDonutTA.resize({ width: width_donus_chart, height: 250 });
    }
    createFakeBarChart('#fake-bar-google', dataDonutChartReviewGoogle, patern);
    createFakeBarChart('#fake-bar-ta', dataDonutChartReviewTA, patern);
    
    const labels = ['5 stars', '4 stars', '3 stars', '2 stars', '1 star'];
    generateLegend('.chart-legend-all', chartDonutGoogle, chartDonutTA, labels);
    generateLegend('.chart-legend-google', chartDonutGoogle, chartDonutTA, labels);
    generateLegend('.chart-legend-ta', chartDonutTA, chartStackBarTA, labels);
    if (rawBarDataGoogle != null && sort_data_column_google.length < 4) {
        var chartStackBarGoogle = generateStackBarReviewChart('#chart-bar-google', rawBarDataGoogle, sort_data_column_google, sort_data_column_google, 'Week', 0.3, false)
        chartStackBarGoogle.resize({ width: width_bar_chart });
    } else{
        var chartStackBarGoogle = generateStackBarReviewChart('#chart-bar-google', rawBarDataGoogle, sort_data_column_google, sort_data_column_google, 'Week', 0.6, false)
        chartStackBarGoogle.resize({ width: width_bar_chart });
    }
    if (rawBarDataTA != null && sort_data_column_ta.length < 4) {
        var chartStackBarTA = generateStackBarReviewChart('#chart-bar-ta', rawBarDataTA, sort_data_column_ta, sort_data_column_ta, 'Week', 0.3, false)
        chartStackBarTA.resize({ width: width_bar_chart });
    } else {
        var chartStackBarTA = generateStackBarReviewChart('#chart-bar-ta', rawBarDataTA, sort_data_column_ta, sort_data_column_ta, 'Week', 0.3, false)
        chartStackBarTA.resize({ width: width_bar_chart });
    }
}

// function generateStackBarReviewChart(bindTo, columns, formatSortDataColumn, sortDataColumn, sortDataType, witdhResize = 890, ratio = 0.6) {
//     c3.generate({
//         bindto: bindTo,
//         data: {
//             columns: columns,
//             type: 'bar',
//             groups: [['5 stars', '4 stars', '3 stars', '2 stars', '1 star']],
//             order: function (a, b) { return a.id[0] - b.id[0] }
//         },
//         bar: {
//             width: {
//                 ratio: ratio
//             }
//         },
//         axis: {
//             x: { type: 'category', categories: formatSortDataColumn, height: 50 },
//             y: { lines: [{value:0}] }
//         },
//         padding: { bottom: 0, top: 0, left: 50, right: 20 },
//         size: { width: 890 },
//         color: { pattern: ['#009e3c', '#7cc522', '#f8f400', '#ee9b00', '#de0023'] },
//         tooltip: {
//             contents: function (d, defaultTitleFormat, defaultValueFormat, color) {
//                 var $$ = this, config = $$.config,
//                     titleFormat = config.tooltip_format_title || defaultTitleFormat,
//                     nameFormat = config.tooltip_format_name || function (name) { return name; },
//                     valueFormat = config.tooltip_format_value || defaultValueFormat,
//                     text, i, title, value, name, bgcolor;
            
//                 var totalReviews = d.reduce(function (sum, item) {
//                     return sum + item.value;
//                 }, 0);
            
//                 d.sort(function (a, b) {
//                     return nameFormat(b.name).localeCompare(nameFormat(a.name));
//                 });
            
//                 for (i = 0; i < d.length; i++) {
//                     if (!(d[i] && (d[i].value || d[i].value === 0))) { continue; }
//                     if (!text) {
//                     title = titleFormat ? sortDataColumn[d[i].x] : d[i].x;
//                     text = "<table class='" + $$.CLASS.tooltip + "'>";
//                     text += "<tr><th>" + sortDataType + ' - ' + title + "</th>";
//                     text += "<th style='text-align:right;'>" + totalReviews + "</th></tr>";
//                     }
//                     name = nameFormat(d[i].name);
//                     value = valueFormat(d[i].value, d[i].ratio, d[i].id, d[i].index);
//                     bgcolor = $$.levelColor ? $$.levelColor(d[i].value) : color(d[i].id);
//                     text += "<tr class='" + $$.CLASS.tooltipName + "-" + d[i].id + "'>";
//                     text += "<td class='name'><span style='background-color:" + bgcolor + "'></span>" + name + "</td>";
//                     text += "<td class='value'>" + value + "</td>";
//                     text += "</tr>";
//                 }
//                 return text + "</table>";
//             }
//         }
//     }).resize({width: witdhResize});
// }

function generateDonutChart(blindTo, colums) {
  return {
    bindto: blindTo,
      data: {
        columns: [
          ['5 stars', colums?.five_star || 0],
          ['4 stars', colums?.four_star || 0],
          ['3 stars', colums?.three_star || 0],
          ['2 stars', colums?.second_star || 0],
          ['1 star', colums?.one_star || 0]
        ],
        type : 'donut',
        labels: true
      },
      color: { pattern: ['#009e3c', '#7cc522', '#f8f300', '#ee9b00', '#de0023'] },
      tooltip: {
        format: {
          value: function (value) {
            return value;
          }
        }
      }
  };
}

$(function() {
    if (!document.getElementById('reviews')) return;
    var total_reviews = $('.chart_total_review').text()

    function manage_review_chart(c3, $) {
        var arr_result_wrapper = [['score']]
        var arr_result_score = [['5 stars'], ['4 stars'], ['3 stars'], ['2 stars'], ['1 star']]
        var arr_result_source = [['Google'], ['Tripadvisor'], ['Viator'], ['GetYourGuide'], ['Expedia']]
        JSON.parse($('.chart_review').text()).forEach((item) => {
            arr_result_score[0].push(item[0]);
            arr_result_score[1].push(item[1]);
            arr_result_score[2].push(item[2]);  
            arr_result_score[3].push(item[3]);
            arr_result_score[4].push(item[4]);
            arr_result_source[0].push(item[5]);
            arr_result_source[1].push(item[6]);
            arr_result_source[2].push(item[7]);
            arr_result_source[3].push(item[8]);
            arr_result_source[4].push(item[9]);
        })
        JSON.parse($('.chart_sort_average').text()).forEach((item) => {
            arr_result_wrapper[0].push(item)
        })
        const sort_data_type = $('.chart_data_type').text()
        const sort_data_column = JSON.parse($('.chart_sort_data').text())
        const format_sort_data_column = sort_data_column.map(date => {
            if (sort_data_type === 'Month') {
                const [month, year] = date.split(' ');
                return `${month} ${year.slice(-2)}`;
            } else {
                return date;
            }
        });
        const customOrder = ['Google', 'Tripadvisor', 'Viator', 'GetYourGuide', 'Expedia'];
        
        if ($('#chart-wrapper').data().tab == 'analytics') {
            generateLineChart('#chart-wrapper', arr_result_wrapper, format_sort_data_column);
            generateStackBarReviewChart('#chart-stack-bar-reviews-overall', arr_result_score, format_sort_data_column, sort_data_column, sort_data_type);
            generateStackBarSourceChart('#chart-stack-bar-sources', arr_result_source, customOrder, format_sort_data_column, sort_data_column, sort_data_type);
        } else {
            const dataChartDonutSources = [
                ['Google', $('#chart-donut-sources').data().sourceReviewsGoogle],
                ['Tripadvisor', $('#chart-donut-sources').data().sourceReviewsTripadvisor],
                ['Viator', $('#chart-donut-sources').data().sourceReviewsViator],
                ['GetYourGuide', $('#chart-donut-sources').data().sourceReviewsGetYourGuide],
                ['Expedia', $('#chart-donut-sources').data().sourceReviewsExpedia],
            ]
            const dataChartDonutReviewOverall = [
                ['5 stars', $('#chart-donut-reviews-overall').data().ratingsExcellent],
                ['4 stars', $('#chart-donut-reviews-overall').data().ratingsVeryGood],
                ['3 stars', $('#chart-donut-reviews-overall').data().ratingsAverage],
                ['2 stars', $('#chart-donut-reviews-overall').data().ratingsPoor],
                ['1 star', $('#chart-donut-reviews-overall').data().ratingsTerrible],
            ]
            const sourcePatern = ['#4285F4', '#34E0A1', '#004757', '#E76037', '#FDDB32']
            const reviewOverallPatern = ['#009e3c', '#7cc522', '#f8f400', '#ee9b00', '#de0023']
            generateLineChart('#chart-wrapper', arr_result_wrapper, format_sort_data_column, 1150);
            const chartDonutReviewOverall = generateDonutChartWithLegend('#chart-donut-reviews-overall', dataChartDonutReviewOverall, reviewOverallPatern);
            chartDonutReviewOverall.resize({ width: 200 });
            const chartDonutSources = generateDonutChartWithLegend('#chart-donut-sources', dataChartDonutSources, sourcePatern);
            chartDonutSources.resize({ width: 200 });
            const chartStackBarReviewOverall = generateStackBarReviewChart('#chart-stack-bar-reviews-overall', arr_result_score, format_sort_data_column, sort_data_column, sort_data_type, 0.3, false, 550);
            const chartStackBarSources = generateStackBarSourceChart('#chart-stack-bar-sources', arr_result_source, customOrder, format_sort_data_column, sort_data_column, sort_data_type, 0.3, false, 550);
            const reviewOveralLabels = ['5 stars', '4 stars', '3 stars', '2 stars', '1 star'];
            generateLegend('.legend-chart-reviews-overall', chartDonutReviewOverall, chartStackBarReviewOverall, reviewOveralLabels);
            generateLegend('.legend-chart-sources', chartDonutSources, chartStackBarSources, customOrder);
        }
    }

    function dashboard_review_chart(c3, $) {
        var arr_result_wrapper = [['score']]
        JSON.parse($('.chart_sort_average').text()).forEach((item) => {
            arr_result_wrapper[0].push(item)
        })
        const sort_data_column = JSON.parse($('.chart_sort_data').text())
        generateLineChart('#chart-wrapper', arr_result_wrapper, sort_data_column, 780);
    }

    function compare_source_chart(c3, $) {
        var arr_result_score_google_90_days = [['score'], ['previous']]
        var arr_result_score_tripadvisor_90_days = [['score'], ['previous']]
        var arr_result_score_viator_90_days = [['score'], ['previous']]
        var arr_result_score_getyourguide_90_days = [['score'], ['previous']]
        var arr_result_score_expedia_90_days = [['score'], ['previous']]
        var arr_result_score_google_1_year = [['score'], ['previous']]
        var arr_result_score_tripadvisor_1_year = [['score'], ['previous']]
        var arr_result_score_viator_1_year = [['score'], ['previous']]
        var arr_result_score_getyourguide_1_year = [['score'], ['previous']]
        var arr_result_score_expedia_1_year = [['score'], ['previous']]
        var arr_result_wrapper_90_days = [['score'], ['previous']]
        var arr_result_wrapper_1_year = [['score'], ['previous']]
        var arr_result_score_google = [['5 stars'], ['4 stars'], ['3 stars'], ['2 stars'], ['1 star']]
        var arr_result_score_tripadvisor = [['5 stars'], ['4 stars'], ['3 stars'], ['2 stars'], ['1 star']]
        var arr_result_score_viator = [['5 stars'], ['4 stars'], ['3 stars'], ['2 stars'], ['1 star']]
        var arr_result_score_getyourguide = [['5 stars'], ['4 stars'], ['3 stars'], ['2 stars'], ['1 star']]
        var arr_result_score_expedia = [['5 stars'], ['4 stars'], ['3 stars'], ['2 stars'], ['1 star']]
        var arr_result_score = [['5 stars'], ['4 stars'], ['3 stars'], ['2 stars'], ['1 star']]
        var arr_result_source = [['Google'], ['Tripadvisor'], ['Viator'], ['GetYourGuide'], ['Expedia']]
        const sort_data_column = JSON.parse($('.chart_sort_data').text())
        const sort_data_type = $('.chart_data_type').text()
        const format_sort_data_column = JSON.parse($('.chart_sort_data').text()).map(date => {
            if ($('.chart_data_type').text() === 'Month') {
                const [month, year] = date.split(' ');
                return `${month} ${year.slice(-2)}`;
            } else {
                return date;
            }
        });

        JSON.parse($('.chart_review').text()).forEach((item) => {
            arr_result_score[0].push(item[0]);
            arr_result_score[1].push(item[1]);
            arr_result_score[2].push(item[2]);
            arr_result_score[3].push(item[3]);
            arr_result_score[4].push(item[4]);
            arr_result_source[0].push(item[5]);
            arr_result_source[1].push(item[6]);
            arr_result_source[2].push(item[7]);
            arr_result_source[3].push(item[8]);
            arr_result_source[4].push(item[9]);
        })


        JSON.parse($('.chart_sort_average').text()).forEach((item) => {
            arr_result_wrapper_90_days[0].push(item)
            arr_result_wrapper_1_year[0].push(item)
        })

        JSON.parse($('.chart_sort_average_90_days').text()).forEach((item) => {
            arr_result_wrapper_90_days[1].push(item)
        })

        JSON.parse($('.chart_sort_average_1_year').text()).forEach((item) => {
            arr_result_wrapper_1_year[1].push(item)
        })

        JSON.parse($('.chart_score_by_source').text()).forEach((item) => {
            arr_result_score_google_90_days[0].push(item[0]);
            arr_result_score_google_1_year[0].push(item[0]);
            arr_result_score_tripadvisor_90_days[0].push(item[1]);
            arr_result_score_tripadvisor_1_year[0].push(item[1]);
            arr_result_score_viator_90_days[0].push(item[2]);
            arr_result_score_viator_1_year[0].push(item[2]);
            arr_result_score_getyourguide_90_days[0].push(item[3]);
            arr_result_score_getyourguide_1_year[0].push(item[3]);
            arr_result_score_expedia_90_days[0].push(item[4]);
            arr_result_score_expedia_1_year[0].push(item[4]);
        })

        JSON.parse($('.chart_score_by_source_90_days').text()).forEach((item) => {
            arr_result_score_google_90_days[1].push(item[0]);
            arr_result_score_tripadvisor_90_days[1].push(item[1]);
            arr_result_score_viator_90_days[1].push(item[2]);
            arr_result_score_getyourguide_90_days[1].push(item[3]);
            arr_result_score_expedia_90_days[1].push(item[4]);
        })

        JSON.parse($('.chart_score_by_source_1_year').text()).forEach((item) => {
            arr_result_score_google_1_year[1].push(item[0]);
            arr_result_score_tripadvisor_1_year[1].push(item[1]);
            arr_result_score_viator_1_year[1].push(item[2]);
            arr_result_score_getyourguide_1_year[1].push(item[3]);
            arr_result_score_expedia_1_year[1].push(item[4]);
        })

        JSON.parse($('.chart_review_by_sources').text()).forEach((item) => {
            arr_result_score_google[0].push(item[0][0]);
            arr_result_score_google[1].push(item[0][1]);
            arr_result_score_google[2].push(item[0][2]);
            arr_result_score_google[3].push(item[0][3]);
            arr_result_score_google[4].push(item[0][4]);
            arr_result_score_tripadvisor[0].push(item[1][0]);
            arr_result_score_tripadvisor[1].push(item[1][1]);
            arr_result_score_tripadvisor[2].push(item[1][2]);
            arr_result_score_tripadvisor[3].push(item[1][3]);
            arr_result_score_tripadvisor[4].push(item[1][4]);
            arr_result_score_viator[0].push(item[2][0]);
            arr_result_score_viator[1].push(item[2][1]);
            arr_result_score_viator[2].push(item[2][2]);
            arr_result_score_viator[3].push(item[2][3]);
            arr_result_score_viator[4].push(item[2][4]);
            arr_result_score_getyourguide[0].push(item[3][0]);
            arr_result_score_getyourguide[1].push(item[3][1]);
            arr_result_score_getyourguide[2].push(item[3][2]);
            arr_result_score_getyourguide[3].push(item[3][3]);
            arr_result_score_getyourguide[4].push(item[3][4]);
            arr_result_score_expedia[0].push(item[4][0]);
            arr_result_score_expedia[1].push(item[4][1]);
            arr_result_score_expedia[2].push(item[4][2]);
            arr_result_score_expedia[3].push(item[4][3]);
            arr_result_score_expedia[4].push(item[4][4]);
        })

        generateNoLabelLineChart('#chart-line-chart-90-days-average', arr_result_wrapper_90_days, format_sort_data_column, 20, 200)
        generateNoLabelLineChart('#chart-line-chart-90-days-google', arr_result_score_google_90_days, format_sort_data_column, 20, 200)
        generateNoLabelLineChart('#chart-line-chart-90-days-tripadvisor', arr_result_score_tripadvisor_90_days, format_sort_data_column, 20, 200)
        generateNoLabelLineChart('#chart-line-chart-90-days-viator', arr_result_score_viator_90_days, format_sort_data_column, 20, 200)
        generateNoLabelLineChart('#chart-line-chart-90-days-getyourguide', arr_result_score_getyourguide_90_days, format_sort_data_column, 20, 200)
        generateNoLabelLineChart('#chart-line-chart-90-days-expedia', arr_result_score_expedia_90_days, format_sort_data_column, 20, 200)
        generateNoLabelLineChart('#chart-line-chart-1-year-average', arr_result_wrapper_1_year, format_sort_data_column, 20, 200)
        generateNoLabelLineChart('#chart-line-chart-1-year-google', arr_result_score_google_1_year, format_sort_data_column, 20, 200)
        generateNoLabelLineChart('#chart-line-chart-1-year-tripadvisor', arr_result_score_tripadvisor_1_year, format_sort_data_column, 20, 200)
        generateNoLabelLineChart('#chart-line-chart-1-year-viator', arr_result_score_viator_1_year, format_sort_data_column, 20, 200)
        generateNoLabelLineChart('#chart-line-chart-1-year-getyourguide', arr_result_score_getyourguide_1_year, format_sort_data_column, 20, 200)
        generateNoLabelLineChart('#chart-line-chart-1-year-expedia', arr_result_score_expedia_1_year, format_sort_data_column, 20, 200)
        generateNoLabelStackBarReviewChart('#chart-stack-bar-reviews', arr_result_score, sort_data_column, format_sort_data_column, sort_data_type, 200)
        generateNoLabelStackBarReviewChart('#chart-stack-bar-reviews-google', arr_result_score_google, sort_data_column, format_sort_data_column, sort_data_type, 200)
        generateNoLabelStackBarReviewChart('#chart-stack-bar-reviews-tripadvisor', arr_result_score_tripadvisor, sort_data_column, format_sort_data_column, sort_data_type, 200)
        generateNoLabelStackBarReviewChart('#chart-stack-bar-reviews-viator', arr_result_score_viator, sort_data_column, format_sort_data_column, sort_data_type, 200)
        generateNoLabelStackBarReviewChart('#chart-stack-bar-reviews-getyourguide', arr_result_score_getyourguide, sort_data_column, format_sort_data_column, sort_data_type, 200)
        generateNoLabelStackBarReviewChart('#chart-stack-bar-reviews-expedia', arr_result_score_expedia, sort_data_column, format_sort_data_column, sort_data_type, 200)
    }

    function compare_product_chart(c3, $) {
        const chartProductIDs = JSON.parse($('.chart_products_id').text())
        if (chartProductIDs.length < 20) {
            return $('.compare-product-content').html(`
            <div class="container rounded-md p-2 border-2 ml-4" style="background-color: #f8f9fa;">
                <p style="font-size: 12px; color: #666; margin-top: 5px;">
                You don’t have enough reviews selected to create graphs and charts. Please change the dates or import more reviews.
                </p>
            </div>
            `);
        }
        const chartProductData = JSON.parse($('.chart_products_data').text())[1]
        const chartProductIDHasData = chartProductData.map(subArray => subArray[0]);
        const format_sort_data_column = JSON.parse($('.chart_sort_data').text()).map(date => {
            if ($('.chart_data_type').text() === 'Month') {
                const [month, year] = date.split(' ');
                return `${month} ${year.slice(-2)}`;
            } else {
                return date;
            }
        });

        chartProductIDs.forEach((item) => {
            const index = chartProductIDHasData.indexOf(item)
            const chartBindings = [
                `#tripadvisor_product_${item}`,
                `#viator_product_${item}`,
                `#getyourguide_product_${item}`,
                `#expedia_product_${item}`,
                `#total_product_${item}`
            ];
            if (index !== -1) {
                const scores = generateScoreArrays(chartProductData[index][3], chartProductData[index][2]);
                let invalidStructure = true
                chartBindings.forEach((binding, i) => {
                    const score = scores[i];
                    invalidStructure = Array.isArray(score) && score.length === 1 &&
                                            Array.isArray(score[0]) && (
                                            score[0].length === 1 || (score[0].length > 1 && score[0].slice(1).every(val => val === 1)));
                    if (invalidStructure) {
                        $(`${binding}`).css({
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }).html(`<div class="flex items-center justify-center container rounded-xl py-2 px-3 border-2 w-4/5 h-24" style="background-color: #f8f9fa;">
                                    <p class="m-0" style="font-size: 12px; color: #666;">
                                        Product not mapped, please visit
                                        <a href="/dashboard/backends?_account=${$('input[name="_account"]').val()}" target="_blank"> your ${binding.split('_')[0].substring(1)} hub</a>
                                        to map
                                    </p>
                                </div>`);
                    } else {
                        generateScatterChart(binding, score, format_sort_data_column, 170);
                    }
                });
            } else {
                $(`.card_chart_product_${item}`).css({
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                }).html(`<div class="flex items-center justify-center container rounded-xl py-2 px-3 border-2 w-4/5 h-24" style="background-color: #f8f9fa;">
                            <p class="m-0" style="font-size: 12px; color: #666;">
                                Product not mapped, please visit
                                <a href="/dashboard/backends?_account=${$('input[name="_account"]').val()}" target="_blank"> your reseller hub</a>
                                to map
                            </p>
                        </div>`);
            }
        })
    }
    
    if ($('.tab_chart_data').text() === 'analytic_review') {
        if (total_reviews >= 20) {
            manage_review_chart(c3, $)
        } else {
            $('.card-chart-overall').html(`
            <div class="text-center rounded-xl p-5 border-2 mb-4" style="background-color: #f8f9fa;">
                <strong style="font-size: 22px; color: #333;">Reviews selected: ${total_reviews}.</strong>
                <p style="font-size: 18px; color: #666; margin-top: 10px;">
                You don’t have enough reviews selected to create graphs and charts. Please change the dates or import more reviews.
                </p>
            </div>
            `);
        }
    } else if ($('.tab_chart_data').text() === 'review_dashboard') {
        if (total_reviews >= 20) {
            manage_review_chart(c3, $)
        } else {
            $('.card-chart-overall').html(`
            <div class="text-center rounded-xl p-5 border-2 mb-4" style="background-color: #f8f9fa;">
                <strong style="font-size: 22px; color: #333;">Reviews selected: ${total_reviews}.</strong>
                <p style="font-size: 18px; color: #666; margin-top: 10px;">
                You don’t have enough reviews selected to create graphs and charts. Please change the dates or import more reviews.
                </p>
            </div>
            `);
        }
    } else if ($('.tab_chart_data').text() === 'dashboard') {
        dashboard_review_chart(c3, $)
    }
    
    $('#compare-source-reviews').on('click', function() {
        if ($('#compare-source-content').hasClass('hidden')) {
            compare_source_chart(c3, $)
            $('#compare-source-content').removeClass('hidden');
            $('#compare-source-reviews').text('Hide');
        } else {
            $('#compare-source-content').addClass('hidden');
            $('#compare-source-reviews').text('Show');
        }
    })
    
    $('#compare-product-reviews').on('click', function() {
        if ($('#compare-product-content').hasClass('hidden')) {
            if ($('.chart_products_data').text() == '') {
                $('#compare-product-content').css({
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }).html(`
                    <div class="rounded-md p-2 border-2 m-4 text-center w-1/3" style="background-color: #f8f9fa;">
                        <p style="font-size: 16px; color: #666; margin-top: 5px;">
                        You don’t have enough reviews selected to create graphs and charts.<br>
                        Please change the dates or import more reviews.
                        </p>
                    </div>
                `);
            } else {
                compare_product_chart(c3, $)
            }
            $('#compare-product-content').removeClass('hidden');
            $('#compare-product-reviews').text('Hide');
        } else {
            $('#compare-product-content').addClass('hidden');
            $('#compare-product-reviews').text('Show');
        }
    })
})
$(function() {
    const elementProfile = document.getElementById('sst-collector-profile');
    const elementTab = document.getElementById('sst-collector-tab');
    const elementPublic = document.getElementById('sst-collector-public');
    
    if (!elementProfile && !elementTab && !elementPublic) return;
    display_chart();
    $('#display-chart').on('click', function() {
      display_chart();
    })
})